import { Base } from "./Base";
import { Partner } from "./Partner";
import { Warehouse } from "./Warehouse";

export enum ProductType {
  MercantileGoods = "MERCANTILE_GOODS", // merkantilna roba
  RawMaterial = "RAW_MATERIAL", // repromaterijal
}

export interface ProductCategory {
  id: string; // PK

  type: ProductType;
  name: string;
  code?: string;
}

export interface Product extends Base {
  id: string; // PK

  type: ProductType;
  code: string; // sifra
  name: string;
  lot?: string; // partija, lot
  amount?: string; // kolicina
  measuringUnit?: string;
  germination?: string; //klijavost (za repromaterijal - semena)
  activeSubstance?: string; //aktivna materija (za repromaterijal - hemija i djubriva)
  expiryDate?: Date; //datum isticanja (za repromaterijal - hemija)
  isWeighbridge?: boolean; //indikator da li se koristi vaga
  isNatural?: boolean; //da li je roba naturalna
  note?: string;

  // category?: string
  category?: ProductCategory;
}

export interface ProductReservation extends Base {
  id: string;
  reservationNumberFormatted?: string;
  warehouse: Warehouse;
  partner: Partner;
  product: Product;
  type?: ProductType;
  category?: ProductCategory;
  amount?: number;
  date?: Date;
  expiryDate?: Date;
  isNotification?: boolean;
  note?: string;
  repromaterialProductsReservationJSON?: string;
  reproProductsRemainingReservationJSON?: string;
  requestId?: string;
  dispositionId?: string;
}

export interface ProductOverview extends Base {
  id: string;
  code?: string;
  name: string;
  year?: number;
  type?: ProductType;
  product: Product;
  mark?: string;
  amount?: number;
  isForeign?: boolean;
}
